import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { LoginComponent } from 'src/app/login/login.component';
import { MensajeComponent } from 'src/app/mensaje/mensaje.component';
import { ClientePagos } from 'src/app/models/cliente-pagos.model';
import { CodigosCortesias } from 'src/app/models/codigo-cortesia';
import { ClientesPagoDataService } from 'src/app/service/data/clientes-pago-data.service';
import { CodigoCortesiaDataService } from 'src/app/service/data/codigo-cortesia-data.service';
import { EventoDataService } from 'src/app/service/data/evento-data.service';
import { TicketDataService } from 'src/app/service/data/ticket-data.service';
import { HardcodedAutheticationService } from 'src/app/service/hardcoded-authetication.service';

@Component({
  selector: 'app-codigo-cortesia',
  templateUrl: './codigo-cortesia.component.html',
  styleUrls: ['./codigo-cortesia.component.css'],
  standalone: false
})
export class CodigoCortesiaComponent implements OnInit {

  codigoCortesia: CodigosCortesias
  evento: any
  localidad: any
  cargando = false;
  cliente: ClientePagos
  usuario: string

  constructor ( 
    private codigoCortesiaService: CodigoCortesiaDataService,
    private eventoService: EventoDataService,
    private ticketService: TicketDataService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private clienteDataService: ClientesPagoDataService,
    private autenticador: HardcodedAutheticationService
  ) { }

  ngOnInit(): void {
    this.cliente = new ClientePagos()
    const codigoId = this.route.snapshot.params['codigoId'];
    this.cargando = true;
    
    this.codigoCortesiaService.findById(codigoId).subscribe(
      codigo => {
        this.codigoCortesia = codigo;
        this.cargarEventoYLocalidad(codigo.localidadId)
      }
    );
  }

  cargarEventoYLocalidad(localidadId: number) {
    this.eventoService.getEventoPorLocalidadId(localidadId).subscribe(
      (response: any) => {
        this.evento = response.evento;
        this.localidad = response.localidad;
        this.cargando = false;
      }
    );
  }

  darURL() {
    const primeraImagenTipo1 = this.evento?.imagenes.find(imagen => imagen.tipo === 1);
    var urlPrimeraImagenTipo1 = "";
    if (primeraImagenTipo1) {
      urlPrimeraImagenTipo1 = primeraImagenTipo1.url;
    }
    return urlPrimeraImagenTipo1
  }
  
  reclamar() {
    if (this.autenticador.getUsuario()) {
      if (this.cliente) {
        this.autenticar().then(() => {

          this.cargando=true;

          this.ticketService.reclamarCortesia(
            this.codigoCortesia.localidadId,
            this.codigoCortesia.id,
            this.cliente
          ).subscribe({
            next: (response) => {
              this.cargando=false
              this.mensaje("Cortesía reclamada exitosamente",false,true);
            },
            error: (error) => {
              this.cargando=false
              this.mensaje(error.error);
            }
          });
        });
      }
    } else {
      this.mensaje("Debes estar registrado en All Tickets para poder reclamar tu ticket, en caso de no estarlo por favor crea una cuenta nueva", true);
    }
  }


  async autenticar() {
    this.usuario = this.autenticador.getCC();
    if (this.usuario) {
        return new Promise((resolve) => {
            this.clienteDataService.getCliente(this.usuario).subscribe({
                next: response => {
                    this.cliente = response;
                    resolve(true);
                },
                error: error => {
                    console.error('Error obteniendo cliente:', error);
                    resolve(false);
                }
            });
        });
    }
    return Promise.resolve(false);
}

mensaje(mensaje: string, login?: boolean, reload?: boolean): void {
    const dialogRef = this.dialog.open(MensajeComponent, {

      width: '600px',
      maxHeight:'250px' ,

      data: {
        mensaje: mensaje,
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      if (login) {
        this.openDialog()
      } if (reload) {
        window.location.reload();
      }
    });
  }
  
  openDialog(): void {
    const dialogRef = this.dialog.open(LoginComponent, {
      width: '600px',
    });

    dialogRef.afterClosed().subscribe(result => {
      this.autenticar()
    });
  }


}
